import { NgbDate } from "@ng-bootstrap/ng-bootstrap";



export class DateRange {
    constructor(){ }

    FromDate: NgbDate=null;
    ToDate: NgbDate=null;


 }
